module.exports = __webpack_public_path__ + "img/packs.e46ff1ab.png";